import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import Header from "../../components/header/Header";
import Logo from "../../components/common/Logo/Logo";
import LogoImge from "../../assets/svg/logo2.svg";

const DefaultLogo = ({ children }) => {
  const user = useSelector((state) => state.user);
  const { userDetail } = user;
  return (
    <>
      <div style={{padding:'18px 0px'}}>
        <img src={LogoImge} alt="" style={{ width: "128px", padding:'20px 0px', marginLeft:'110px' }} />
        <div >
          <Container>{children}</Container>
        </div>
      </div>
      {user?.isAdminLoggedIn && (
        <div id="footer">&copy; 2022 All Rights Reserved</div>
      )}
    </>
  );
};

export default DefaultLogo;
